import { Link } from "react-router-dom";
import { URL } from "../../routers/constants";

const Page404 = () => {
   return (
      <div className="page-404">
         <div id="bot-scene-container" className="">
            <div id="bot-scene-content" className="scroll-light">
               <div id="page404" className="row">
                  <div className="col-md-6 flex-display logo-404">
                     <div className="svg-next-icon icon-404">
                     </div>
                  </div>
                  <div className="col-md-4 flex-display-col info-404">
                     <div className="width100 text-center mb20">
                        <span className="text-404">404</span>
                     </div>
                     <div className="width100 text-center mb10">
                        <span className="text-error text-uppercase">
                           Lỗi! Không tìm thấy
                           trang
                        </span>
                     </div>
                     <div className="width100 text-center mb42">
                        <span className="text-noti">
                           Xin lỗi, nội dung bạn tìm kiếm không tồn tại.
                        </span>
                     </div>
                     <div className="width100 text-center">
                        <Link to={URL.HOME}>
                           <span className="btn btn-primary btn-back-home">
                              Quay về Trang chủ
                           </span>
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}

export default Page404;